import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import { HomeSchema } from '@/components/base/HomeSchema';
import HeroSection from './components/HeroSection';
import HotComicsSection from './components/HotComicsSection';
import CategorySection from './components/CategorySection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEO
        title="韩国漫画无删减漫画下拉式-免费韩漫大全-51漫画网"
        description="51漫画网提供无删减韩国漫画下拉式阅读服务，免费韩漫大全题材丰富多样，更新及时、资源优质，为您打造便捷高效的韩漫阅读平台。"
        keywords="韩国漫画,无删减漫画,下拉式漫画,免费韩漫大全,51漫画网,韩漫高效阅读"
        canonical="https://51manhua.com/"
      />
      <HomeSchema />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotComicsSection />
          <CategorySection />
          <TestimonialSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}